import { render, staticRenderFns } from "./ClientPaymentsTab.vue?vue&type=template&id=bcb230fa"
import script from "./ClientPaymentsTab.vue?vue&type=script&lang=js"
export * from "./ClientPaymentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports